/**
 * The back office canvas tint (plan 19 §4.13): staff must never confuse the back office with a
 * tenant app, so in the light theme the canvas (the Fluent `colorNeutralBackground3` variable the
 * shell and its header paint) is a cool grey-blue instead of the tenants' warm Béton.
 * This is the only place the value lives. Contrast: ink #0B2545 on #EEF1F5 is above 13:1.
 * Dark and high-contrast themes keep their own canvas.
 */
export const BACKOFFICE_CANVAS_LIGHT = '#EEF1F5';
